import { render } from "./TextBoxGroup.vue?vue&type=template&id=3818f328&scoped=true"
import script from "./TextBoxGroup.vue?vue&type=script&lang=js"
export * from "./TextBoxGroup.vue?vue&type=script&lang=js"

import "./TextBoxGroup.vue?vue&type=style&index=0&id=3818f328&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3818f328"]])

export default __exports__